import { request } from '@langlois/request';

export async function getProduct ({ commit }, { instanceId, purpose}) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/subscription/product?instanceId=${instanceId}&purpose=${purpose}`);

		const response = await request.get(url);

		if (!response.ok) return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while retrieving the subscriptions.`,
			type: `warning`
		}, { root: true });

		const products = await response.json();

		commit(`products`, products);
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while retrieving the subscriptions.`,
			type: `warning`
		}, { root: true });
	}
}
